export const SELECTED = "SET_SELECTED";

export const setSelectedRelationship = (name) => {
	return {
		type: SELECTED,
		name,
	};
};
